export function getFieldDisplayValue(value: string | string[] | boolean | number): string {
  if (Array.isArray(value)) return value.join(', ')
  if (typeof value === 'boolean') return value ? 'Yes' : 'No'
  return String(value ?? '')
}
